import styled from '@emotion/styled';

import Button from '../../ComponentLibrary/oc-button';
import Table from '../../ComponentLibrary/oc-table';
import RichText from '../../OC/oc-rich-text';

export const CustomizedHeader = styled.div`
  ul,
  ol {
    margin: 0;
    padding: 0;

    li {
      margin: 0;
    }
  }
`;

export const DensityCalculatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 4vw;
  margin-top: -16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const DensitySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h3 {
    font-size: 28px;
    line-height: 28px;
    font-weight: bold;
    text-transform: none;
    font-family: 'OCRoboto', sans-serif;
    margin: 0;
  }
`;

export const Content = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const CustomizedRichText = styled(RichText)`
  ul,
  ol {
    margin: 0;
    padding: 0;

    li {
      margin: 0;
    }
  }
`;

export const SectionImageGalery = styled.ul`
  list-style: none;
  display: flex;
  gap: 4vw;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  margin-top: ${props => (props.withContent ? '-42px' : '0')};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 12px;
  }

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  p {
    font-size: 20px;
    line-height: 18px;
    font-weight: bold;
  }
`;

export const CalculatorSection = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormContainer = styled.div`
  background-color: #e6e6e6;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'OCRoboto', sans-serif;
  width: 35%;
  max-width: 370px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const FormTitle = styled.h5`
  font-size: 20px;
  line-height: 20px;
  font-weight: bold;
  border-bottom: 1px solid #000;
  padding-bottom: 8px;
  margin: 0;
`;

export const CalculateButton = styled(Button)`
  background-color: ${props => props.themeColor || '#336c40'};
  text-transform: uppercase;
  max-width: 130px;

  &:hover {
    background-color: white;
    color: ${props => props.themeColor || '#336c40'};
    border: 1px solid ${props => props.themeColor || '#336c40'};
  }
`;

export const TableContainer = styled.div`
  flex: 1;
`;

export const DesktopTableWrapper = styled(Table)`
  @media (max-width: 768px) {
    display: none;
  }

  thead {
    th {
      text-transform: none;
      border-top: 3px solid #bcbcbc;
      border-bottom: 3px solid #bcbcbc;
      font-size: 14px;
      padding: 20px 5px;
    }
  }

  tbody {
    tr:first-of-type {
      background-color: #f8f8f8;

      td {
        font-size: 16px;
        line-height: 16px;
        text-align: center;
      }
    }

    tr + tr {
      td:first-of-type {
        text-align: center;
      }

      td {
        font-family: 'Oswald', sans-serif;
        font-size: 28px;
        line-height: 30px;
        text-align: center;
        font-weight: 600;

        @media (max-width: 768px) {
          font-size: 20px;
          line-height: 26px;
        }
      }
    }
  }
`;

export const MobileTableWrapper = styled(Table)`
  display: none;
  table-layout: fixed;

  @media (max-width: 768px) {
    display: table;
    width: 100%;

    tbody {
      tr {
        td {
          font-size: 16px;
          line-height: 18px;
          text-align: left;
          padding: 10px 0;
        }

        td + td {
          padding: 10px;
        }
      }

      tr:nth-of-type(odd) {
        background-color: #f8f8f8;
      }
    }
  }
`;

export const DensityValues = styled.td`
  color: #336c40;
  font-family: 'Oswald', sans-serif;
  font-size: 28px;
  line-height: 30px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 26px;
    text-wrap: nowrap;
  }

  span:first-of-type {
    margin-right: 8px;
  }

  span {
    font-weight: normal;
    color: #000;
    font-size: 12px;
    line-height: 18px;
  }
`;

export const FooterContainer = styled.div`
  font-size: 12px;
  line-height: 18px;
  margin-top: 24px;
  width: 76%;

  table {
    border: 1px solid #000;
    border-collapse: collapse;

    td {
      border: 1px solid #000;
      padding: 4px;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
